// Centralized branding configuration.
// Never hard-code the product name elsewhere — import from here (master context §7.1).
export const branding = {
  productName: process.env.REACT_APP_PRODUCT_NAME || "ResFil AI",
  tagline:
    "Answer every call, capture every lead and book more appointments — without hiring another receptionist.",
  shortTagline: "Your AI front desk, working 24/7.",
  supportEmail: "support@resfil.ai",
  primaryAccent: "#2563EB",
} as const;

export type Branding = typeof branding;
